module.exports = __webpack_public_path__ + "static/screenshot-e80a16cd1a80620779cf02aa2643c4b2.png";